import { defineMessages } from 'react-intl';

export default defineMessages({
    removeDocument: {
        id: 'cecl.policy.common.component.documents.Remove Document',
        defaultMessage: 'Remove Document'
    },
    confirmRemoveDocument: {
        id: 'cecl.policy.common.component.documents.Are you sure you want to remove',
        defaultMessage: 'Are you sure you want to remove'
    },
    documentRemoveConfirmYes: {
        id: 'cecl.policy.common.component.documents.Yes',
        defaultMessage: 'Yes'
    },
    documentRemoveConfirmNo: {
        id: 'cecl.policy.common.component.documents.No',
        defaultMessage: 'No'
    },
    documentDeletionFailed: {
        id: 'cecl.policy.common.component.documents.Document deletion failed',
        defaultMessage: 'Document deletion failed'
    },
    documentCannotDeleted: {
        id: 'cecl.policy.common.component.documents.Sorry your document could not be deleted at this time',
        defaultMessage: 'Sorry your document could not be deleted at this time'
    },
    documentDateUploaded: {
        id: 'cecl.policy.common.component.documents.Date Uploaded',
        defaultMessage: 'Date Uploaded'
    },
    documentUploadFailed: {
        id: 'cecl.policy.common.component.documents.Document upload failed',
        defaultMessage: 'Document upload failed'
    },
    documentCannotUploaded: {
        id: 'cecl.policy.common.component.documents.Failed to upload file, either you do not have permission or a file exists with the same name.',
        defaultMessage: 'Failed to upload file, either you do not have permission or a file exists with the same name.'
    },
    noDocumentFound: {
        id: 'cecl.policy.common.component.documents.No Documents Found.',
        defaultMessage: 'No Documents Found.'
    },
    uploadedDocuments: {
        id: 'cecl.policy.common.component.documents.Upload Documents',
        defaultMessage: 'Uploaded Documents'
    },
    policyDocuments: {
        id: 'cecl.policy.common.component.documents.Policy Document',
        defaultMessage: 'Policy Documents'
    }
});
